import { createAction, union } from '@ngrx/store';
import { PhoneNumber } from 'src/app/models/auth/phone-number';

export const storeVeriricationId = createAction(
  'AccountActions storeVeriricationId',
  (payload: string) => ({ payload }),
);

export const storePhoneNumber = createAction(
  'AccountActions storePhoneNumber',
  (payload: PhoneNumber) => ({ payload }),
);

export const showMailConfirmModal = createAction(
  'AccountActions showMailConfirmModal',
  (payload: boolean) => ({ payload }),
);

export const showUpdatePasswordSuccessModal = createAction(
  'AccountActions showUpdatePaswordSuccessModal',
  (payload: boolean) => ({ payload }),
);

export const updateLoading = createAction(
  'AccountActions updateLoading',
  (payload: boolean) => ({ payload }),
);

export const storeErrorMessage = createAction(
  'AccountActions storeErrorMessage',
  (payload: string) => ({ payload }),
);

export const resetState = createAction('AccountActions resetState');

const all = union({
  storeVeriricationId,
  storePhoneNumber,
  showMailConfirmModal,
  showUpdatePasswordSuccessModal,
  updateLoading,
  storeErrorMessage,
  resetState,
});
export type AccountActionsUnion = typeof all;
